import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';

import { toggleBlackBoxFileUploader } from 'store/entities/blackbox';
import BlackBoxUpload from './BlackBoxUpload';

import Hero from 'react-bulma-components/lib/components/hero';
import Card from 'react-bulma-components/lib/components/card';
import { Column, Container, Row } from 'components/UIComponents/Layout';
import { Content, Heading } from 'components/UIComponents/Typography';
import Button from 'components/UIComponents/Button';

import '../Landing/style.scss';

const BlackBoxSubmission = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    userDetails: { firstName, lastName, blackBoxTypeName },
  } = useSelector(state => state.auth);

  return (
    <div className="landing">
      <Hero color="white" size="medium">
        <Hero.Body className="has-bg-img card-image" />
      </Hero>
      <Container>
        <Card>
          <Row breakpoint="tablet" role="main">
            <Column size={10} offset={1} className="pb-5">
              <div className="flex center-content flex-center-y pb-5">
                <Heading size={1}>
                  {t('datagate.external.blackBoxSubmission.greeting', {
                    name: `${firstName} ${lastName}`,
                  })}
                </Heading>
              </div>
              <div className="flex center-content flex-center-y pb-5">
                <Button
                  id="upload-btn"
                  color="primary"
                  onClick={() => dispatch(toggleBlackBoxFileUploader(true))}
                >
                  {t('datagate.external.blackBoxSubmission.button.upload')}
                </Button>
              </div>

              <Content className="pb-5">
                <p>
                  {t('datagate.external.blackBoxSubmission.text.paragraph1', {
                    role: blackBoxTypeName,
                  })}
                </p>
                <p>
                  <Trans
                    components={{
                      mailTo: <a href={'mailto: stat@stat.stat'}> </a>,
                    }}
                  >
                    datagate.external.blackBoxSubmission.text.paragraph2
                  </Trans>
                </p>
              </Content>
            </Column>
          </Row>
        </Card>
        <BlackBoxUpload />
      </Container>
    </div>
  );
};

export default BlackBoxSubmission;
